import { FormControl, InputLabel, Select, OutlinedInput, MenuItem } from '@mui/material'
import { useReadPropertySpyListQuery } from 'services/propertySpy'
import { WarningIcon } from 'shared/icons/WarningIcon'
import styles from './PropertySpySelectorContainer.module.css'

interface PropertySpySelectorContainerProps {
    propertySpyId?: number
    onPropertySpyChange: (value: number | undefined) => void
}

export const PropertySpySelectorContainer = (props: PropertySpySelectorContainerProps): JSX.Element => {
    const {
        propertySpyId,
        onPropertySpyChange
    } = props

    const {
        data: readPropertySpyListQuery,
        isLoading: readPropertySpyListQueryIsLoading,
        isFetching: readPropertySpyListQueryIsFetching
    } = useReadPropertySpyListQuery({})

    const handlePropertySpyChange = (event: any) => {
        onPropertySpyChange?.(event.target.value)
    }

    const renderWarning = (row: any) => {
        if (row.newChanges === true) {
            return (
                <WarningIcon sx={{ color: '#FFF', fontSize: '32px' }} />
            )
        }

        return ''
    }

    return (
        <FormControl required sx={{ width: 350, mt: 2, '& *': { fontSize: '20px' } }}>
            <InputLabel id="PropertySpyListLabel">Property Spies</InputLabel>
            <Select
                labelId="PropertySpyListLabel"
                id="PropertySpiesLabelSelector"
                value={propertySpyId ? propertySpyId?.toString() : ''}
                onChange={handlePropertySpyChange}
                input={<OutlinedInput label="Property Spies" />}
            >
                {
                    readPropertySpyListQuery
                        ?.list
                        ?.filter((monitor: any) => monitor.mode !== 2)
                        .map((row: any) => {
                            return <MenuItem key={row.id} value={row.id}>
                                <div className={styles.PropertySpyList_Item}>               
                                    <div className={styles.PropertySpyList_ItemName}>{row.strHostServiceName}</div>
                                    <div style={{ "width": "32px" }} >{
                                        renderWarning(row)
                                    }</div>
                                </div>
                            </MenuItem>
                        })
                }
            </Select>
        </FormControl>
    )
}